import {Component, Input} from '@angular/core';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-home-why-card-blue',
  imports: [],
  templateUrl: './home-why-card-blue.component.html',
})
export class HomeWhyCardBlueComponent {

  @Input()
  reduced = true
  protected readonly environment = environment;
}
